module.exports = __webpack_public_path__ + "static/media/logo-mark.197ec0be.svg";